/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";

interface PaginationProps {
  data: any[];
  indexOfFirstItem: number;
  indexOfLastItem: number;
  currentItems: any[];
  pages: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  pageNumbers: number[];
  itemsPerPage: number;
  setItemsPerPage: (items: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  data,
  indexOfFirstItem,
  indexOfLastItem,
  currentItems,
  pages,
  currentPage,
  setCurrentPage,
  pageNumbers,
  itemsPerPage,
  setItemsPerPage,
}) => {


  // Limit visible page numbers to 5
  const maxVisiblePages = 5;
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = startPage + maxVisiblePages - 1;

  if (endPage > pages) {
    endPage = pages;
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  const visiblePages = pageNumbers.slice(startPage - 1, endPage);
  return (
    <div>
      {currentItems.length > 0 && (
        <nav className="pagination-wrap mb-4">
          {/* <div className="row g-3 align-items-center justify-content-between"> */}
          {/* Showing items info */}
          <div className="col-12 col-md-4">
            <p className="mb-0 text-center text-md-start">
              Showing {indexOfFirstItem + 1} to{" "}
              {Math.min(indexOfLastItem, data.length)} of {data.length} items
            </p>
          </div>

          {/* Items per page */}
          <div className="col-12 col-md-4 d-flex justify-content-center">
            <div className="d-flex align-items-center gap-2">
              <label htmlFor="itemsPerPage" className="mb-0">
                Items per page
              </label>
              <select
                id="itemsPerPage"
                className="form-select form-select-sm w-auto"
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1); // reset page
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
            </div>
          </div>

          {/* Pagination buttons */}
          <div className="col-12 col-md-4">
            <ul className="pagination justify-content-center justify-content-md-end mb-0 flex-wrap">
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(1)}
                  disabled={currentPage === 1}
                >
                  <i className="material-symbols-outlined">first_page</i>
                </button>
              </li>
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <i className="material-symbols-outlined">navigate_before</i>
                </button>
              </li>
          
              {visiblePages.map((number) => (
                <li key={number} className="page-item">
                  <button
                    className={`page-link ${number === currentPage ? "active" : ""}`}
                    onClick={() => setCurrentPage(number)}
                  >
                    {number}
                  </button>
                </li>
              ))}
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage === pages}
                >
                  <i className="material-symbols-outlined">navigate_next</i>
                </button>
              </li>
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(pages)}
                  disabled={currentPage === pages}
                >
                  <i className="material-symbols-outlined">last_page</i>
                </button>
              </li>
            </ul>
          </div>
          {/* </div> */}
        </nav>
      )}
    </div>
  );
};

export default Pagination;
